import { alpha, Box, Button, IconButton, Tooltip, useTheme } from '@mui/material';
import React from 'react';
import ShowChartIcon from '@mui/icons-material/ShowChart';

function FluctuationChartAction({ data, handleOpenChart }) {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      justifyContent={{ md: 'center', xs: 'flex-end' }}
      alignItems="center"
    >
      {data?.unitTradeId ? (
        <IconButton onClick={() => handleOpenChart(data)}>
          <ShowChartIcon sx={{ color: theme.palette.modules.menuIconColor }} />
        </IconButton>
      ) : (
        <IconButton disabled>
          <ShowChartIcon sx={{ color: alpha(theme.palette.modules.menuIconColor , 0.5) }} />
        </IconButton>
      )}
    </Box>
  );
}

export default FluctuationChartAction;
